import { Divider, Paper, Stack, Typography } from '@mui/material';
import type { ChartsItemContentProps } from '@mui/x-charts/ChartsTooltip';
import { isNullOrUndefined } from '@weft/utils';
import { formatNumber } from '@weft/utils';
import { ColorDot } from 'apps/app/src/components/design/ColorDot';

type CustomerCommitmentUsageChartToolTipProps = {
  customerNames: string[];
} & ChartsItemContentProps<'bar'>;

export const CustomerCommitmentUsageChartToolTip: React.FC<CustomerCommitmentUsageChartToolTipProps> = ({ customerNames, ...props }) => {
  const { itemData, series } = props;

  if (isNullOrUndefined(itemData.dataIndex) || itemData.dataIndex > 11) {
    return null;
  }
  
  const seriesLabel = typeof series.label === 'string' ? series.label : series.label?.('tooltip');
  const customerName = customerNames[itemData.dataIndex];
  const itemValue = series.data[itemData.dataIndex];
  const dotColor = props.getColor(itemData.dataIndex);

  return (
    <Paper sx={{
      backgroundColor: '#0D1B27DE',
      width: '250px',
      transform: 'translate(-50%, -120%)',
    }}
    >
      <Stack
        direction="column"
        alignItems="start"
        gap={1}
      >
        <Stack
          direction="row"
          justifyContent="center"
          alignItems="center"
          width="100%"
          paddingX={1}
          paddingTop={1}
        >
          <Typography
            fontSize="13px"
            lineHeight="14px"
            fontWeight={400}
            textAlign="center"
            color="white"
          >
            {seriesLabel}
          </Typography>
          <Typography
            fontSize="12px"
            lineHeight="14px"
            fontWeight={400}
            textAlign="center"
            color="#90A4AE"
            marginLeft="auto"
          >
            {customerName}
          </Typography>
        </Stack>
        <Divider
          color='#37474F'
          sx={{ width: '100%' }}
        />
        <Stack
          paddingBottom={1}
          paddingX={1}
          direction="row"
          alignItems="center"
          gap={0.5}
        >
          <ColorDot
            sizeOverride='8px'
            color={dotColor}
          />
          <Typography
            fontSize="14px"
            lineHeight="18px"
            fontWeight={500}
            textAlign="center"
            color="white"
          >
            {formatNumber(itemValue ?? undefined)}
          </Typography>
        </Stack>
      </Stack>            
    </Paper>
  );
};